import { PhoneCall, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useMesProspects } from '@/hooks/useCommercial';

/**
 * SIMG-COMMERCIAL-LEADBETON-2026-001 — Prospects du commercial.
 *
 * Utilise le pipeline commercial existant (`/crm/pipeline`) — l'écran ici est
 * une vue mobile-ready qui liste les opportunités actives et pointe vers le
 * pipeline complet pour l'édition.
 */
export const MesProspectsPage = () => {
  const { data = [], isLoading } = useMesProspects();

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
        <div>
          <h1 style={{ margin: '0 0 4px', fontSize: 22, fontWeight: 800 }}>Prospects</h1>
          <p style={{ margin: 0, color: 'var(--tx-3, #6B7280)', fontSize: 13 }}>
            Opportunités en cours à recontacter
          </p>
        </div>
        <Link
          to="/crm/pipeline"
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 13,
            color: 'var(--pr-1, #1F4E79)', textDecoration: 'none',
          }}
        >
          Pipeline complet <ExternalLink size={13} />
        </Link>
      </div>

      {isLoading && <div style={{ padding: 24, textAlign: 'center', color: 'var(--tx-3)' }}>Chargement…</div>}

      {!isLoading && data.length === 0 && (
        <div style={{ background: '#fff', border: '1px solid var(--bd-1)', borderRadius: 12, padding: 32, textAlign: 'center' }}>
          <PhoneCall size={40} style={{ color: 'var(--tx-3)', marginBottom: 8 }} />
          <p style={{ color: 'var(--tx-3)', margin: 0, fontSize: 14 }}>
            Aucun prospect actif. Utilise le pipeline commercial pour en créer.
          </p>
        </div>
      )}

      <div style={{ display: 'grid', gap: 10 }}>
        {data.map((o: any) => (
          <div key={o.id} style={{
            background: '#fff', border: '1px solid var(--bd-1)', borderRadius: 12, padding: 12,
            display: 'flex', flexDirection: 'column', gap: 4,
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <div style={{ fontWeight: 700, fontSize: 14 }}>{o.contact?.fullName ?? '—'}</div>
                {o.contact?.companyName && (
                  <div style={{ fontSize: 12, color: 'var(--tx-3)' }}>{o.contact.companyName}</div>
                )}
              </div>
              <div style={{ fontSize: 11, color: 'var(--tx-3)', textAlign: 'right' }}>
                {o.stage}
                {o.probabilityPct != null && (
                  <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--tx-1)' }}>{o.probabilityPct}%</div>
                )}
              </div>
            </div>
            <div style={{ fontSize: 13 }}>{o.title}</div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: 'var(--tx-3)', marginTop: 4 }}>
              <span>
                {o.expectedCloseDate && (
                  <>Clôture prévue {new Date(o.expectedCloseDate).toLocaleDateString('fr-FR')}</>
                )}
              </span>
              {o.contact?.phone && (
                <a
                  href={`tel:${o.contact.phone}`}
                  style={{ color: 'var(--pr-1)', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 4 }}
                >
                  <PhoneCall size={12} /> Appeler
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
